import { Component, Inject, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { SnackbarService } from '../snackbar.service';
import { EpodsPrevComponent } from '../epods-prev/epods-prev.component';
@Component({
  selector: 'app-common-confirmation',
  templateUrl: './common-confirmation.component.html',
  styleUrls: ['./common-confirmation.component.scss']
})
export class CommonConfirmationComponent implements OnInit {
  
  constructor(@Inject(MAT_DIALOG_DATA) private parentData: any,private http: HttpService, private dialog: MatDialogRef<CommonConfirmationComponent>, private parentDialog: MatDialogRef<EpodsPrevComponent>, private snackbar: SnackbarService) { } 

  ngOnInit() {

  }

  close(){
    this.dialog.close();
  }
  deleteEpod() {
    this.http.post('shipment/delete_epod', this.parentData).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.dialog.close();
          this.snackbar.openSnackBar('ePOD deleted successfully', '');
          this.parentDialog.close(true);
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );

  }

}
